<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      @click="openDrawerPermissions"
      type="success"
      icon="el-icon-plus"
      circle
    ></el-button>
    <div style="display: flex; float: right">
      <div class="box">
        <el-select
          v-model="year"
          placeholder="Año"
          size="mini"
          @change="handleChangeYear"
        >
          <el-option
            v-for="item in years"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="box">
        <el-select
          v-model="type"
          placeholder="Tipo"
          size="mini"
          @change="handleChangeType"
        >
          <el-option
            v-for="item in requestType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <DirectionSelector
        v-if="
          this.currentUser.EmployeeId == 37 ||
          this.IsInRoles([this.roles.GerenteRRHH])
        "
        @selection-change="handleChangeDirection"
      ></DirectionSelector>
    </div>
    <div style="text-align: center; margin-bottom: 20px">
      <label><b>PENDIENTES POR APROBAR:</b></label>
      <br />
      <label
        :style="PeddingRequestAproveRRRHH > 0 ? 'color: red' : 'color: black'"
        ><b>RRHH:</b> {{ PeddingRequestAproveRRRHH }}</label
      >
      <br />
      <label
        :style="PeddingRequestAproveSuper > 0 ? 'color: red' : 'color: black'"
        ><b>SUPERVISOR:</b> {{ PeddingRequestAproveSuper }}</label
      >
    </div>
    <div>
      <rabbey-table-3
        ref="table"
        :loading="autoLoading"
        :data="DataPermission"
        :columns="ColumnsPermissionMonths"
        show-summary
        :summary-method="getSummaries"
      ></rabbey-table-3>
    </div>

    <!-- Componente de leyenda de colores -->
    <ColorInfot :ColorAndDescription="colorInfot" style="margin-top: 2%" />

    <!-- Add permission request DrawerPermission -->
    <DrawerPermission
      :openDrawerPermission.sync="openDrawerPermission"
      :dataPermissions="DataPermission"
      :type="type"
      @dialog-closed="closeDrawerPermissions"
    />

    <PermissionsReportForMes
      :showDrawerPermissionReport="showDrawerPermissionReport"
      :UserId="IdUser"
      :Month="Month"
      :year="year2"
      :type="type"
      @dialog-closed="closeDrawerDetalles"
      :before-close="closeDrawerDetalles"
      @refreshTable2="getDataPermission"
    ></PermissionsReportForMes>
  </div>
</template>

<script>
//components
import DirectionSelector from "@/components/Company/DirectionSelector.vue";
import DrawerPermission from "@/views/apps/employees/RRHH/Modules/Permission/DrawerPermission.vue";
import PermissionsReportForMes from "@/views/apps/employees/RRHH/Modules/Permission/PermissionsReportForMes.vue";

//columns
import ColumnsPermissionMonth from "@/views/apps/employees/RRHH/Modules/Permission/columns/ColumnsPermissionMonth.js";

//helpers
import ColorInfot from "@/views/apps/employees/RRHH/Modules/Permission/helpers/ColorInfot.vue";
import GetPendingRequestAproved from "@/views/apps/employees/RRHH/Modules/GetPendingRequestAproved.js";
export default {
  name: "Permission",
  components: {
    DirectionSelector,
    DrawerPermission,
    PermissionsReportForMes,
    ColorInfot
  },
  data() {
    return {
      ColumnsPermissionMonths: ColumnsPermissionMonth,
      openDrawerPermission: false,
      showDrawerPermissionReport: false,
      autoLoading: false,
      DataPermission: [],
      directionId: 0,
      year: new Date().getFullYear(),
      type: "License",
      requestType: {
        0: { value: "License", label: "Licencia" },
        1: { value: "Permission", label: "Permiso" },
        2: { value: "Absence", label: "Ausencia" }
      },
      IdUser: null,
      Month: null,
      year2: null,
      PeddingRequestAproveRRRHH: 0,
      PeddingRequestAproveSuper: 0,
      colorInfot: [
        //Array de colores para la leyenda de informacion
        {
          Color: "rgba(234, 22, 22, 0.301)",
          Description: "Solicitado sin Aprobación"
        },
        {
          Color: "rgba(231, 235, 5, 0.377)",
          Description: "Aprobado por supervisor"
        },
        { Color: "rgba(2, 255, 107, 0.459)", Description: "Aprobado por RRHH" },
        { Color: "rgba(25, 133, 187, 0.281)", Description: "Ejecutado" },
        { Color: "rgba(167, 124, 32, 0.473)", Description: "Rechazado" }
      ]
    };
  },
  computed: {
    years() {
      const lowLevel = 2021;
      const currentYear = new Date().getFullYear();
      let Years = [];
      for (var i = lowLevel; i <= currentYear + 2; i++) {
        Years.push({ label: i, value: i });
      }
      return Years;
    }
  },
  mounted() {
    this.getDataPermission();
  },
  watch: {
    refresh() {
      this.getDataPermission();
    }
  },
  methods: {
    getDataPermission() {
      this.autoLoading = true;
      GetPendingRequestAproved(this, 2, this.type);
      let employeeID = //Si es RRHH o Id Ceo manda elemployeeId null para que aparezcan todos lo colaboradores
        this.currentUser.EmployeeId == 37 ||
        this.IsInRoles([this.roles.GerenteRRHH])
          ? null
          : this.currentUser.EmployeeId;

      let params = {
        directionId: this.directionId == 0 ? null : this.directionId,
        year: this.year == 0 ? null : this.year,
        EmployeeID: employeeID,
        type: this.type
      };
      this.$http
        .get("/api/Modules/GetPermissionsList", { params })
        .then((resp) => {
          this.DataPermission = resp.data;
          this.DataPermission.forEach((waos) => {
            waos.OpenDetailPermission = this.OpenDetailPermission;
          });
        })
        .finally(() => {
          this.autoLoading = false;
        });
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },

    openDrawerPermissions() {
      this.openDrawerPermission = true;
    },
    closeDrawerPermissions() {
      this.openDrawerPermission = false;
      this.getDataPermission();
    },
    handleChangeDirection(directionId) {
      this.directionId = directionId;
      this.getDataPermission();
    },
    handleChangeYear(year) {
      this.year = year;
      this.getDataPermission();
    },
    handleChangeType(type) {
      this.type = type;
      this.getDataPermission();
    },
    closeDrawerDetalles() {
      this.showDrawerPermissionReport = false;
      this.getDataPermission();
    },
    OpenDetailPermission(row, month, years, type) {
      let mtn;
      switch (month) {
        case "Enero":
          mtn = 1;
          break;
        case "Febrero":
          mtn = 2;
          break;
        case "Marzo":
          mtn = 3;
          break;
        case "Abril":
          mtn = 4;
          break;
        case "Mayo":
          mtn = 5;
          break;
        case "Junio":
          mtn = 6;
          break;
        case "Julio":
          mtn = 7;
          break;
        case "Agosto":
          mtn = 8;
          break;
        case "Septiembre":
          mtn = 9;
          break;
        case "Octubre":
          mtn = 10;
          break;
        case "Noviembre":
          mtn = 11;
          break;
        case "Diciembre":
          mtn = 12;
          break;
        default:
      }
      this.IdUser = row.Id;
      this.Month = mtn;
      this.year2 = years;
      this.type = type;
      this.showDrawerPermissionReport = true;
    }
  }
};
</script>

<style></style>
